import { authRequest } from "../utils/netRequest";

export class ProfileService {
  async updateProfile({ firstName, lastName, email }) {
    return await authRequest({
      url: "/profile",
      method: "patch",
      data: {
        firstName,
        lastName,
        email,
      },
    });
  }
}

export default new ProfileService();


